import React, { useEffect, useState } from 'react';
import MetisMenu from 'metismenujs';
import { withRouter, Link } from 'react-router-dom';
import { withNamespaces } from 'react-i18next';

import {
  Users,
  Shield,
  KeyRound,
  ClipboardList,
  Ticket,
  Package,
  Book,
  Library,
  FileText,
  ClipboardCheck,
  HelpCircle,
  File,
  Tags,
} from 'lucide-react';

import { fetchRequestWithToken } from '../../service/index';

// 2. Define all sidebar links as an array of objects. This is much cleaner!
const mainLinks = [
  { path: '/users', title: 'Users', icon: Users, authRoute: 'users' },
  { path: '/roles', title: 'Roles', icon: Shield, authRoute: 'roles' },
  { path: '/authcodes', title: 'Auth Code', icon: KeyRound, authRoute: 'authCodes' },
  { path: '/tasks', title: 'Tasks', icon: ClipboardList, authRoute: 'tasks' },
  { path: '/coupons', title: 'Coupons', icon: Ticket, authRoute: 'coupons' },
  { path: '/products-list', title: 'Products', icon: Package, authRoute: 'products' },
];

const contentLinks = [
  { path: '/subjects', title: 'Subjects', icon: Book, authRoute: 'subjects' },
  { path: '/chapters', title: 'Chapters', icon: Library, authRoute: 'chapters' },
  { path: '/studyguides', title: 'Study Guides', icon: FileText, authRoute: 'studyguides' },
  { path: '/assessments', title: 'Assessments', icon: ClipboardCheck, authRoute: 'assessments' },
  { path: '/questions', title: 'Questions', icon: HelpCircle, authRoute: 'questions' },
  { path: '/case-studies', title: 'Case Studies', icon: File, authRoute: 'caseStudies' },
  { path: '/question-tagging', title: 'Questions Tagging', icon: Tags, authRoute: 'question-tagging' },
];


const SidebarContent = (props) => {
  const [userAuthRoutes, setUserAuthRoutes] = useState([]);

  useEffect(() => {
    const initMenu = () => {
      new MetisMenu('#side-menu');
      const pathName = props.location.pathname;
      const ul = document.getElementById('side-menu');
      if (!ul) return;

      const items = ul.getElementsByTagName('a');
      let matchingMenuItem = null;

      for (let i = 0; i < items.length; ++i) {
        if (pathName === items[i].pathname) {
          matchingMenuItem = items[i];
          break;
        }
      }
      if (matchingMenuItem) {
        activateParentDropdown(matchingMenuItem);
      }
    };

    const fetchUserRoles = async () => {
      try {
        if (localStorage.getItem('authUser')) {
          const response = await fetchRequestWithToken({
            url: `roleroute?type=ui`,
            method: 'GET',
          });
          if (!response.ok) {
            throw new Error(`HTTP error! Status: ${response.status}`);
          }
          const data = await response.json();
          const allowedRoutes = data.rolePermission.map(p => p.routePath);
          setUserAuthRoutes(allowedRoutes);
        }
      } catch (error) {
        console.error('Error fetching user roles:', error);
      }
    };

    fetchUserRoles();
    initMenu();
  }, [props.location.pathname]);

  function activateParentDropdown(item) {
    item.classList.add('active');
    const parent = item.parentElement;
    if (!parent) return;

    parent.classList.add('mm-active');
    const parent2 = parent.parentElement;
    if (!parent2) return;

    parent2.classList.add('mm-show');
    const parent3 = parent2.parentElement;
    if (!parent3) return;

    parent3.classList.add('mm-active'); // li
    parent3.childNodes[0].classList.add('mm-active'); // a
    const parent4 = parent3.parentElement;
    if (parent4) {
      parent4.classList.add('mm-active');
    }
  }

  // Helper function to render a menu item
  const renderMenuItem = (link) => {
    // We check if the route is present in our fetched permissions
    if (!userAuthRoutes.includes(link.authRoute)) {
      return null;
    }

    // The Icon component is passed directly
    const Icon = link.icon;

    return (
      <li key={link.path}>
        <Link to={link.path} className="waves-effect">
          <Icon className="sidebar-icon" size={20} strokeWidth={1.5} />
          <span>{props.t(link.title)}</span>
        </Link>
      </li>
    );
  };


  return (
    <React.Fragment>
      <div id="sidebar-menu">
        <ul className="metismenu list-unstyled" id="side-menu">

          {/* 3. Render the links by mapping over the arrays */}
          {mainLinks.map(renderMenuItem)}

          <li className="menu-title">CONTENT</li>

          {contentLinks.map(renderMenuItem)}

        </ul>
      </div>
    </React.Fragment>
  );
};

export default withRouter(withNamespaces()(SidebarContent));